import { createAction } from 'redux-act';

export const clearEnquiry = createAction('ENQUIRY/CLEAR_ENQUIRY');
export const createEnquiry = createAction('ENQUIRY/CREATE_ENQUIRY');
export const setEnquiry = createAction('ENQUIRY/SET_ENQUIRY');
export const setEnquiryStatus = createAction('ENQUIRY/SET_STATUS');
export const setEnquiryError = createAction('ENQUIRY/SET_ERROR');
